// extracted by mini-css-extract-plugin
export default {"taskItemWrapper":"TaskItem_taskItemWrapper__UwQLC","shineLoop":"TaskItem_shineLoop__9Eezd"};